import React from "react";
import Button from "../components/Button";
import { Link } from "react-router-dom";

const BrandingSection6 = () => {
  return (
    <div className="mt-auto pb-16 px-10 xl:px-35 text-black dark:text-white">
      <div className="mb-8 w-full">
        <div className="flex items-center justify-center xl:justify-start">
          <p className="dark:text-zinc-500 font-semibold text-sm mb-2 flex gap-2 text-center xl:text-left">
            We know you want to{" "}
            <img
              className="h-5"
              src="https://flamingo-agency.com/wp-content/uploads/2024/08/512.gif"
              alt=""
            />
          </p>
        </div>
        <div className="w-full flex flex-col xl:flex-row justify-between xl:items-center gap-15 xl:gap-0">
          <h2 className="text-4xl xl:text-5xl font-bold leading-tight text-center xl:text-left">
            We know you want to get<br className="hidden xl:block" />{" "} onboarded 
            on a project or?
            <br className="hidden xl:block" /> Have a Query?
          </h2>
          <Link
            to={"/contact"}
            className="flex xl:inline justify-center items-center"
          >
            <Button>Contact Us</Button>
          </Link>
        </div>
      </div>

      <div className="border-t border-zinc-600 pt-8">
        <p className="dark:text-gray-300 text-zinc-500 text-lg max-w-2xl text-center xl:text-left">
          For the strongest brands, it’s not just what you say,{" "}
          <br className="hidden xl:block" />
          it’s how you say it.
        </p>
      </div>
    </div>
  );
};

export default BrandingSection6;
